module.exports = __webpack_public_path__ + "static/media/  (68).a692cb0c.jpg";